import React from "react";

function Ewallet() {
  return (
    <section className="e-wallet">
      <div className="container">klkklklkl </div>
    </section>
  );
}

export default Ewallet;
